import {lazyInitialize, nonenumerable} from 'core-decorators';

import APIRequestState from 'spa/state/_util/api-request';

class OrdersCalculateUpdateRequest extends APIRequestState {
  putRequest(urlId, ...params) {
    return this.ctx.sdk.post(`/orders/${urlId}/calculate-update`, ...params);
  }
}

class OrdersCalculateUpdateState {
  /*
   * Lazy load our required state
   */
  @lazyInitialize @nonenumerable calculateUpdate = new OrdersCalculateUpdateRequest(this.ctx);

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default OrdersCalculateUpdateState;



// WEBPACK FOOTER //
// ./spa/state/orders-calculate-update.jsx